@if (document) {
  <div>
    <document-lines-editor
      #lineGrid
      [title]="'Doc::StockDoc:Products' | abpLocalization"
      [columnDefs]="colDefs"
      [rows]="_document.lines"
      [getContextMenuItems]="getContextMenuItems"
      [onCellFocused]="onCellFocused"
      [onRowSelected]="onRowSelected"
      [onCellValueChanged]="onCellValueChanged"
      [treeData]="true"
      [getDataPath]="getDataPath"
      [readonly]="_readonly"
      [canAddLines]="true"
      [addActionBtns]="addActionBtns"
      [deleteActionEnabled]="deleteActionEnabled"
      [selectedLines]="selectedLines()"
      (deleteLines)="deleteLines()"
      [isBusyAdding]="isBusyAdding"
      [actionBtns]="actionBtns"
      (onModelUpdated)="onModelUpdated($event)"
    ></document-lines-editor>
  </div>
}
